import React from 'react';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { BeneficiarySectionStyles } from './BeneficiarySection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

interface BeneficiaryBottomSectionProps {
  goBack: () => unknown;
}

const BeneficiaryBottomSection: React.FC<BeneficiaryBottomSectionProps> = ({
  goBack
}) => {
  return (
    <BeneficiarySectionStyles className="bottom-section">
      <div>
        <FontAwesomeIcon
          icon={faCircleQuestion}
          className="icon"
          size="2x"
          color={COLORS.ctaPrimary}
        />
      </div>
      <div className="content">
        <div className="heading">
          <TrueImpactText variant="heading">
            Don’t see what you’re looking for?
          </TrueImpactText>
        </div>
        <TrueImpactText variant="body-large">
          <button onClick={goBack} className="link">
            Go back to the category selection
          </button>{' '}
          if you need to add another category.
        </TrueImpactText>
      </div>
    </BeneficiarySectionStyles>
  );
};

export default React.memo(BeneficiaryBottomSection);
